import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import { Truck, Boxes } from "lucide-react";import { useTranslation } from 'react-i18next';


const NAVBAR_HEIGHT = 80;

export default function BusinessLogin() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">

      {/* ================= PAGE SECTION ================= */}
      <section
        className="relative overflow-hidden"
        style={{ paddingTop: NAVBAR_HEIGHT }}
      >
        {/* BACKGROUND EFFECT */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(124,58,237,0.15),transparent_55%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(99,102,241,0.15),transparent_55%)]" />
        </div>

        <div className="relative container mx-auto px-4 py-24">
          {/* HEADER */}
          <div className="text-center max-w-3xl mx-auto mb-14">
            <p
              className="
                inline-block text-sm uppercase tracking-widest
                bg-gradient-to-r from-purple-100 via-purple-50 to-indigo-100
                px-4 py-1.5 rounded-full font-semibold text-purple-700 mb-4
              "
            >
              Business Access
            </p>

            <h1 className="text-3xl md:text-4xl font-semibold text-gray-800">
              Choose Your Platform Login
            </h1>

            <p className="mt-4 text-gray-600 text-md">
              Access your dashboard securely based on your business module.
            </p>
          </div>

          {/* ================= LOGIN BOXES ================= */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto">
            {/* ===== DQ LOGIX ===== */}
            <div
              className="
                group relative rounded-xl p-8
                bg-white/70 backdrop-blur-md
                border border-purple-100
                shadow-lg
                transition-all duration-300
                hover:-translate-y-1 hover:shadow-xl
              "
            >
              {/* ICON */}
              <div
                className="
                  w-14 h-14 rounded-xl
                  bg-purple-100
                  flex items-center justify-center
                  mb-6
                "
              >
                <Truck className="w-7 h-7 text-purple-700" />
              </div>

              {/* TITLE */}
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                DQ-Logix Login
              </h3>

              {/* DESC */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                Login to manage shipments, trips, expenses, PODs, settlements
                and real-time profit & loss — all from one unified logistics
                platform.
              </p>

              {/* CTA */}
              <button
                onClick={() => navigate("/login/dq-logix")}
                className="
                  inline-flex items-center gap-2
                  px-5 py-2.5 rounded-md
                  bg-purple-900 text-white
                  text-sm font-semibold
                  transition-all duration-300
                  hover:shadow-[0_12px_30px_rgba(99,102,241,0.4)]
                "
              >
                Go to DQ-Logix Login →
              </button>
            </div>

            {/* ===== DQ IMS ===== */}
            <div
              className="
                group relative rounded-xl p-8
                bg-white/70 backdrop-blur-md
                border border-purple-100
                shadow-lg
                transition-all duration-300
                hover:-translate-y-1 hover:shadow-xl
              "
            >
              {/* ICON */}
              <div
                className="
                  w-14 h-14 rounded-xl
                  bg-purple-100
                  flex items-center justify-center
                  mb-6
                "
              >
                <Boxes className="w-7 h-7 text-purple-700" />
              </div>

              {/* TITLE */}
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                DQ-IMS Login
              </h3>

              {/* DESC */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                Login to track inventory, manage warehouses, monitor stock
                movement, alerts, and valuation with complete accuracy.
              </p>

              {/* CTA */}
              <button
                onClick={() => navigate("/login/dq-ims")}
                className="
                  inline-flex items-center gap-2
                  px-5 py-2.5 rounded-md
                  bg-purple-900 text-white
                  text-sm font-semibold
                  transition-all duration-300
                  hover:shadow-[0_12px_30px_rgba(99,102,241,0.4)]
                "
              >
                Go to DQ-IMS Login →
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}